import React from 'react';
import '../css/Footer.css';

const Footer = () => {
    const schoolName = 'St. Therese of the Child Jesus Multiple Intelligence School';
    const schoolAddress = 'GC Berberabe Commercial Area, Pallocan East, Batangas City';
    const schoolNumber = '(043) 723-1608'
    const schoolEmail = 'stcj_mis@yahoo.com.ph';
    const schoolFB = 'https://www.facebook.com/stcjmis?mibextid=LQQJ4d'


    return (
        <div className='footer-container flex-center image'>
            <div className='footer-header palanquin-dark primary-yellow-text bold'>Contact Us!</div>
            <div className='footer-details-container flex-center'>
                <div className='footer-left-pane'>
                    <div className='secondary-white-text inter bold'>{schoolName}</div>
                    <div className='flex-center footer-text-icon-container'>
                        <div className='image footer-text-icon location'/>
                        <div className='secondary-white-text inter regular address'>{schoolAddress}</div>
                    </div>
                </div>
                <div className='footer-right-pane'>
                    <div className='flex-center footer-text-icon-container'>
                        <div className='image footer-text-icon fb'/>
                        <div className='secondary-white-text inter regular'>
                            <a href={schoolFB} target="_blank" rel="noopener noreferrer">{schoolName}</a>
                        </div>
                    </div>
                    <div className='flex-center footer-text-icon-container'>
                        <div className='image footer-text-icon phone'/>
                        <div className='secondary-white-text inter regular'>
                            <a href="tel:+63437231608">{schoolNumber}</a>
                        </div>
                    </div>
                    <div className='flex-center footer-text-icon-container'>
                        <div className='image footer-text-icon email'/>
                        <div className='secondary-white-text inter regular'>
                            <a href="mailto:example@example.com">{schoolEmail}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;